import type { TestingProcessStep } from '@/models/shop-swab-kit.model';

export const testingProcessSteps: TestingProcessStep[] = [
  {
    title: 'Purchase your kit',
    description: 'One time cost, Ships free, and get results back in 5-7 days.',
  },
  {
    title: 'Collect & ship your sample to our CLIA-certified and CAP-accredited laboratory ',
    description: 'Your DNA is processed, and de-identified to remain private and secure forever.',
  },
  {
    title: 'Receive results within 1-2 weeks',
    description:
      'Get your personalized health and fitness report complete with your 13 unique genetic traits.',
  },
  {
    title: 'Speak with a Fitness Expert',
    description:
      'They will walk you through your DNA results, personalized insights on food, exercise, and the most effective path to your health goals.',
  },
];
